import React from 'react';
import Colors from '../../assets/colors/Colors';

const DIAMETER = 124;
const STROKE_WIDTH = 3;

interface Props {
    rank: number,
    isLife?: boolean,
}

const FilledCircle: React.FC<Props> = ({rank, isLife}) => {
    const radius = (DIAMETER - rank) / 2;

    return (
        <circle
            cx={radius}
            cy={DIAMETER - radius}
            r={radius}
            fill={ isLife ? Colors.fontWhite : Colors.fontGray }
            style={{'filter': '0px 3px 6px #00000029'}}
        />
    );
};

const BorderCircle = (props: Props) => {
    return (
        <circle
            cx={DIAMETER / 2}
            cy={DIAMETER / 2}
            r={DIAMETER / 2}
            stroke={ props.isLife ? Colors.fontWhite : Colors.fontGray }
            strokeWidth={STROKE_WIDTH}
            fill="none"
            style={{'filter': '0px 3px 6px #00000029'}}
        />
    );
};

const FillableCircle: React.FC<Props> = ({rank, isLife}) => {
    if (!rank) return null;
    return (
        <svg
            width={DIAMETER + STROKE_WIDTH}
            height={DIAMETER + STROKE_WIDTH}
            viewBox={`-10 -10 ${DIAMETER + STROKE_WIDTH + 10} ${DIAMETER + STROKE_WIDTH + 10}`}>
            <BorderCircle rank={rank} isLife={isLife} />
            <FilledCircle rank={rank} isLife={isLife}/>
        </svg>
    );
};

export default FillableCircle;
